import React, { Component, PropTypes } from "react";
import LeftComponent from "components/Authorization/LeftComponent";
import ForgotPasswordForm from "components/Authorization/ForgotPassword/ForgotPasswordForm";
import { connect } from "react-redux";
import actions from "actions";

const { forgotPasswordSaga } = actions;

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "" };
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.props.forgotPassword(this.state.email);
  };

  onFieldChange = (e) => {
    const newState = {
      ...this.state,
      [e.target.name]: e.target.value,
    };

    this.setState(newState);
  };

  render() {
    return (
      <main className="">
        <div className="container_content_signin">
          <LeftComponent />
          <ForgotPasswordForm
            email={this.state.email}
            onFieldChange={this.onFieldChange}
            onSubmit={this.onSubmit}
          />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  forgotPassword: (email) => dispatch(forgotPasswordSaga(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/Authorization/ForgotPassword/ForgotPassword.js